var Base = require('_js/base'),
  $ = require('jquery');

function BlockMagazine() {
  this.init();
}

var blockMagazine = {
  init: function() {
    var $blocks = $('.magazine-block .block-content'),
      self = this;

    if (!$blocks.length) {
      return;
    }

    $(window).on('load resize', function() {
      self.updateHeights($blocks);
    });

    self.updateHeights($blocks);
  },

  updateHeights: function(blocks) {
    var self = this;

    blocks.each(function() {
      var $divContent = $(this).find('div.truncate');
      // setting max-height tells dotdotdot.js where to truncate
      $divContent.css('max-height', self.getContentMaxHeight(this));
    });

    // wait for dotdotdot to do its thing
    setTimeout(function() {
      self.matchHeights(blocks);
    }, 100);
  },
  getContentMaxHeight: function(block) {
    var lines = 7;

    var $heading = $(block).find('h3');

    var headingLineHeight = this.getLineHeight($heading);
    var textLineHeight = this.getLineHeight($(block).find('p'));

    var headingLineCount = $heading.outerHeight() / headingLineHeight;
    headingLineCount = Math.ceil(headingLineCount);

    lines -= headingLineCount;
    return textLineHeight * lines;
  },
  matchHeights: function(blocks) {
    var heightMax = 0;

    blocks.each(function() {
      var blockHeight = $(this).outerHeight();
      if (blockHeight > heightMax) {
        heightMax = blockHeight;
      }
    });

    // Temporary hotfix for oversized block heights
    if (heightMax > 250) {
      heightMax = 250;
    }

    blocks.each(function() {
      $(this).css('min-height', heightMax);
    });
  },
  getLineHeight: function($el) {
    return parseFloat($el.css('lineHeight'));
  }
};

BlockMagazine.prototype = Object.assign(new Base(), blockMagazine);

module.exports = BlockMagazine;
